import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

const DialogGeneral = forwardRef(
  ({ selectedItems, handleAction, label = "name", header = "Confirm Delete", title = "Are you sure you want to delete?", actionName = "Delete" }, ref) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    useImperativeHandle(ref, () => ({
      open: () => setOpen(true),
      close: () => setOpen(false),
    }));

    const handleCancel = () => {
      setOpen(false);
    };

    return (
      <Dialog open={open} onClose={handleCancel}>
        <DialogTitle>
          <Typography variant="Dialog Title">{t(header)}</Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex" }}>
            <Typography variant="Dialog Content">{t(title)}</Typography>
          </Box>
          {selectedItems.map((s, i) => (
            <Box key={i} sx={{ display: "flex", justifyContent: "right" }}>
              <Typography key={i} variant="Dialog Content" sx={{ textAlign: "right", textWrap: "wrap" }}>
                {s?.[label]}
              </Typography>
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} variant="outlined">
            {t("Cancel")}
          </Button>
          <Button
            onClick={() => {
              handleAction(selectedItems);
              setOpen(false);
            }}
            color="error"
            variant="contained">
            {t(actionName)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default DialogGeneral;
